import React, { useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { userLoginApi } from "../server/rolesAllApi";
import "./Signin.css";
import {
  Snackbar,
  Alert,
} from "@mui/material";

const SignInLayer = () => {
  const [user, setUser] = useState({
    username: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const navigate = useNavigate();

  const handleUserLogin = async (e) => {
    e.preventDefault();
    const { username, password } = user;

    if (!username || !password) {
      // Swal.fire({
      //   icon: "info",
      //   title: "Oops...",
      //   text: "Please fill the form completely!",
      // });
      setSnackbarMessage("Please fill the form completely!");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      return;
    }

    try {
      const res = await userLoginApi({ username, password });
      if (res.status === 200) {
        // Swal.fire({
        //   title: "Good job!",
        //   text: "Login Successful!",
        //   icon: "success",
        // });

        localStorage.setItem("user", JSON.stringify(res.data.user));
        localStorage.setItem("token", res.data.token);

        navigate("/dashboard", { replace: true });
        // Clear the form
        setUser({ username: "", password: "" });
      } else if (res.status === 403) {
        // Swal.fire({
        //   icon: "info",
        //   title: "Oops...",
        //   text: "Invalid username or password",
        // });
        // console.log(res?.response?.data?.message || "Access denied");
        
        setSnackbarMessage(res?.response?.data?.message || "Access denied");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      } else {
        // Swal.fire({
        //   icon: "info",
        //   title: "Oops...",
        //   text: "Invalid username or password",
        // });
        setSnackbarMessage("Invalid username or password");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error(error);
      // Swal.fire({
      //   icon: "error",
      //   title: "Oops...",
      //   text: error.response?.data?.message || "Something went wrong!",
      // });
      setSnackbarMessage(error.response?.data?.message || "Something went wrong!");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <section className="auth bg-base d-flex flex-wrap logdes">
      <div className="auth-left d-lg-block d-none">
        <div className="SignBanner d-flex align-items-center flex-column h-100 justify-content-center">
          <img src="assets/images/Logo/screen 1 – 242.png" alt="" />
        </div>
      </div>
      <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center" >
        <div className="max-w-464-px mx-auto w-100">
          <div>
            <Link to="/" className="mb-40 max-w-290-px">
              <img src="assets/images/Logo/Educate 2 trade.png" alt="" />
            </Link>
            <h4 className="mb-12 accsign">Sign In to your Account</h4>
            <p className="mb-32 text-secondary-light text-lg">
              Welcome back! Please enter your details
            </p>
          </div>
          <form onSubmit={handleUserLogin}>
            <div className="icon-field mb-16">
              <span className="icon top-50 translate-middle-y">
                <Icon icon="mage:user" />
              </span>
              <input
                type="text"
                className="form-control h-56-px bg-neutral-50 radius-12"
                placeholder="Username"
                value={user.username}
                required
                onChange={(e) =>
                  setUser((prevState) => ({
                    ...prevState,
                    username: e.target.value,
                  }))
                }
              />
            </div>
            <div className="position-relative mb-20">
              <div className="icon-field">
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="solar:lock-password-outline" />
                </span>
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control h-56-px bg-neutral-50 radius-12"
                  id="your-password"
                  placeholder="Password"
                  value={user.password}
                  required
                  onChange={(e) =>
                    setUser((prevState) => ({
                      ...prevState,
                      password: e.target.value,
                    }))
                  }
                />
                <button
                  type="button"
                  className="btn btn-link position-absolute end-0 top-50 translate-middle-y pe-3"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ border: "none", background: "none" }}
                >
                  <Icon icon={showPassword ? "mdi:eye" : "mdi:eye-off" } />
                </button>
              </div>
            </div>
            {/* <span
                className="toggle-password ri-eye-line cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light"
                data-toggle="#your-password"
              /> */}

            {/* <div className="d-flex justify-content-between gap-2">
              <div className="form-check style-check d-flex align-items-center">
                <input
                  className="form-check-input border border-neutral-300"
                  type="checkbox"
                  id="remember"
                />
                <label className="form-check-label" htmlFor="remember">
                  Remember me
                </label>
              </div>
            </div> */}
            <button
              type="submit"
              className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
            >
              Sign In
            </button>
          </form>
        </div>
      </div>
      <Snackbar
                open={openSnackbar}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
              >
                <Alert
                  onClose={handleCloseSnackbar}
                  severity={snackbarSeverity}
                  sx={{ width: "100%" }}
                >
                  {snackbarMessage}
                </Alert>
              </Snackbar>
    </section>
  );
};

export default SignInLayer;
